import * as React from 'react';
import { ProjectModel } from '../../../../models';
import Controller, { IAbstractDashboardControllerProps } from '../../common/CommonDashboardController';
import View from './ProjectsTableView';

interface IProjectViewControllerState {
    projects: ProjectModel[]
    limit: number
    skip: number
    dataCount: number
    searchText: string
}

class ProjectViewController<P, S> extends Controller<P, S & IProjectViewControllerState> {

    public static defaultProps: Partial<IAbstractDashboardControllerProps> = {
        title: 'Проекты'
    }

    constructor(props: any) {
        super(props);
        this.state = {
            loading: false,
            projects: [],
            skip: 0,
            limit: 25,
            dataCount: 0,
            searchText: ''
        } as any;
    }

    public async fia_componentWillMount() {
        this.setState({ loading: true });
        await this.loadProjects();
    }

    public async onEditProject(projectId: string) {
        this.props.history['push']('/projects/add', { projectId })
    }

    public async onNewProject() {
        this.props.history['push']('/projects/add')
    }

    public async loadProjects(s?: number, l?: number) {
        const { limit, skip } = this.state;
        const projects = await ProjectModel.loadProjects(s || s === 0 ? s : skip, l ? l : limit);
        const dataCount = await ProjectModel.getProjectsCount();
        this.setState({ projects, dataCount, loading: false });
    }

    public async onProjectDelete(projects: ProjectModel[]) {
        await this.setState({ loading: true });
        await ProjectModel.deleteAllProjects(projects);
        await this.loadProjects();
    }

    public async onSearchProject(sText: string, l?: number, s?: number) {
        const { limit, skip } = this.state;
        this.setState({ searchText: sText });
        const projects = await ProjectModel.searchProject(sText, l || l === 0 ? l : limit, s || s === 0 ? s : skip) as ProjectModel[];
        const dataCount = await ProjectModel.searchProject(sText, l || l === 0 ? l : limit, s || s === 0 ? s : skip, true) as number;
        this.setState({ dataCount, projects, loading: false });
    }

    public async onChangePage(page: number) {
        const { limit, searchText } = this.state;
        const currentSkip = page * limit;
        this.setState({ skip: currentSkip, loading: true });
        if (searchText) {
            await this.onSearchProject(searchText, limit, currentSkip);
        } else {
            await this.loadProjects(currentSkip);
        }
    }

    public async onChangeRowPerPage(rPP: number) {
        const { searchText } = this.state;
        this.setState({ limit: rPP, loading: true });
        if (this.state.searchText) {
            await this.onSearchProject(searchText, rPP, this.state.skip);
        } else {
            await this.loadProjects(this.state.skip, rPP);
        }
    }


    public async onSaveServiePublishedState(i: number, c: boolean) {
        this.setState({ loading: true });
        const { projects } = this.state;
        projects[i].published = c;
        await projects[i].save();
        setTimeout(() => {
            this.setState({ loading: false });
        }, 400);
    }

    public dashboard_render(): JSX.Element {
        const { loading, projects, limit, dataCount } = this.state
        return <View
            accessAvailable={this.accessAvailable}
            onConfirmDelete={(ps: ProjectModel[]) => this.onProjectDelete(ps)}
            model={projects}
            onEditProject={(sId: string) => this.onEditProject(sId)}
            loading={loading}
            onSearchProject={(s: string) => this.onSearchProject(s)}
            rowsPerPage={limit}
            dataCount={dataCount}
            onChangePage={(cP: number) => this.onChangePage(cP)}
            onNewProject={() => this.onNewProject()}
            onSaveProjectPublishedState={(i: number, s: boolean) => this.onSaveServiePublishedState(i, s)}
            onChangeRowsPerPage={(rPP: number) => this.onChangeRowPerPage(rPP)}
        />
    }
}

export default ProjectViewController;



// WEBPACK FOOTER //
// ./src/app/dashboard/project/main/ProjectsTableViewController.tsx